<template>
  <div class="page_tax">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="税款所属期" size="small">
              <el-date-picker v-model="listQuery.reportingMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="申报公司" size="small">
              <el-select v-model="listQuery.PayrollCompany" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="税号" size="small" v-if="activeName2=='0'">
              <el-input v-model="listQuery.taxId" style="width:180px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small" v-if="activeName2!='0'">
              <el-select v-model="listQuery.projectId" size="small" filterable clearable placeholder="">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="117px">
          <div>
            <el-form-item label="批次状态" size="small">
              <el-select v-model="listQuery.batchStatus" placeholder="" size="small" style="width: 180px;" clearable filterable>
                <el-option value="0" label="未生成"></el-option>
                <el-option value='1' label="已生成"></el-option>
                <el-option value="2" label="确认退回"></el-option>
                <el-option value="3" label="提交确认"></el-option>
                <el-option value="4" label="已确认"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="税号" size="small" v-if="activeName2=='1'">
              <el-input v-model="listQuery.taxId" style="width:180px" size="small"></el-input>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>个税</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="报税确认" name="待确认" v-if="checkPermission(['incomeDtl_TBC'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="报税信息维护" name="所得明细" v-if="checkPermission(['incomeDtl_incomeDtl'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="个税草稿" name="个税草稿" v-if="checkPermission(['incomeDtl_tax'], permissionLists)"></el-tab-pane>

          <el-tab-pane label="待申报" name="待申报" v-if="checkPermission(['incomeDtl_declared'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="申报中" name="申报中" v-if="checkPermission(['incomeDtl_declareding'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="申报成功" name="申报成功" v-if="checkPermission(['incomeDtl_declaredSuccess'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="申报失败" name="申报失败" v-if="checkPermission(['incomeDtl_declaredFail'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="扣除信息" name="扣除信息" v-if="checkPermission(['incomeDtl_deduction'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="预扣实缴差异" name="预扣实缴差异" v-if="checkPermission(['incomeDtl_wapd'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="个税申报设置" name="个税申报设置" v-if="checkPermission(['incomeDtl_taxApplySet'], permissionLists)"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="公司" name="0" v-if="roleName=='管理员' || roleName=='财务出纳' || roleName=='数据管理员'"></el-tab-pane>
          <el-tab-pane label="项目（报税总人数）" name="1"></el-tab-pane>
          <el-tab-pane label="当月报税人员" name="2" v-if="activeName!='待确认'"></el-tab-pane>
          <!-- <el-tab-pane label="当月发薪人员" name="5" v-if="activeName=='待确认'"></el-tab-pane> -->
          <el-tab-pane label="零申报人员" name="3" v-if="activeName=='个税草稿' || activeName=='待申报'"></el-tab-pane>
          <!-- <el-tab-pane label="奖金人员" name="4" v-if="activeName=='待确认'"></el-tab-pane> -->
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="warning" size="small" v-if="activeName2=='0' && activeName == '个税草稿' && checkPermission(['incomeDtl_taxGenerate'], permissionLists)" @click="generateBatch">生成个税草稿</el-button>
          <!-- <el-button type="danger" size="small" v-if="activeName2=='0' && activeName == '个税草稿'" @click="showAllGenerate = true">全部生成个税草稿</el-button> -->
          <el-button type="primary" v-if="activeName2=='0' && activeName == '个税草稿' && checkPermission(['incomeDtl_taxSubmit'], permissionLists)" style="background:rgba(199, 21, 133, 1);color:#fff;border-color: rgba(199, 21, 133, 1);" size="small" @click="batchSubmit">提交客服确认</el-button>

          <el-button type="warning" size="small" v-if="activeName == '待确认' && checkPermission(['incomeDtl_TBCConfirm'], permissionLists)" @click="batchConfirmCompany">确认</el-button>
          <el-button type="danger" size="small" v-if="activeName2=='0' && activeName == '待确认' && checkPermission(['incomeDtl_TBCRevoke'], permissionLists)" @click="batchRevoke">撤销待确认</el-button>

          <el-button type="warning" size="small" v-if="activeName2=='0' && activeName == '待申报' && checkPermission(['incomeDtl_declaredSubmit'], permissionLists)" @click="batchApply('0')">选中申报</el-button>
          <el-button type="danger" size="small" v-if="activeName2=='0' && activeName == '待申报' && checkPermission(['incomeDtl_declaredSubmit2'], permissionLists)" @click="batchApply('1')">零申报算税</el-button>
          <!-- <el-button type="danger" size="small" v-if="activeName2=='0' && activeName == '待申报'">全部申报</el-button> -->
          <el-button type="success" size="small" @click="exportList">导出</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" :row-class-name="tableRowClassName" style="width:100%" @selection-change="handleSelectionChange" :key="'company'" v-if="activeName2=='0' || activeName2=='1'">
          <el-table-column type="selection" width="40" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="reportingMonth" label="税款所属期" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            <template slot-scope={row}>{{row.reportingMonth!=undefined && row.reportingMonth ? row.reportingMonth.substring(0,7) : ''}}</template>
          </el-table-column>
          <div v-if="activeName2=='0'">
            <el-table-column prop="payRollCompany" label="公司" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName2=='0'">
            </el-table-column>
            <el-table-column prop="taxId" label="税号" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="batchStatus" label="个税草稿状态" min-width="120" :show-overflow-tooltip="true" align="center" v-if="activeName=='个税草稿'">
              <template slot-scope={row}>{{row.batchStatus==0 ? '未生成' : row.batchStatus==1 ? '已生成' : row.batchStatus==2 ? '确认退回' :  row.batchStatus==3 ? '提交确认' : '已确认'}}</template>
            </el-table-column>
            <el-table-column prop="batchCount" label="个税草稿人数" min-width="120" :show-overflow-tooltip="true" align="center" v-if="activeName!='待申报'">
            </el-table-column>
            <el-table-column prop="confirmedCount" label="已确认人数" v-if="activeName=='待确认'" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="batchCount" label="所属期申报人数" v-if="activeName=='待申报'" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="payrollPaymentCount" label="所属期发薪人数" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="beOnTheJobCount" label="所属期在职人数" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="untreatedJobCount" label="所属期离职人数" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="checkSuccess" label="校验成功人数" v-if="activeName=='待申报'" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="checkFaild" label="校验失败人数" v-if="activeName=='待申报'" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cacuSuccess" label="算税成功人数" v-if="activeName=='待申报'" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cacuFaild" label="算税失败人数" v-if="activeName=='待申报'" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="生成时间" min-width="150" :show-overflow-tooltip="true" align="center" v-if="activeName=='个税草稿'">
              <template slot-scope={row}>{{row.createTime!=undefined && row.createTime ? row.createTime.replace('T',' ') : ''}}</template>
            </el-table-column>
            <el-table-column prop="applyTime" label="提交确认时间" min-width="150" :show-overflow-tooltip="true" align="center" v-if="activeName!='个税草稿'&&activeName!='待申报'">
              <template slot-scope={row}>{{row.applyTime!=undefined && row.applyTime ? row.applyTime.replace('T',' ') : ''}}</template>
            </el-table-column>
            <el-table-column prop="actuallyInComeResult" label="申报失败原因" v-if="activeName=='申报失败'" min-width="200" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="applyTime" label="完成确认时间" min-width="150" :show-overflow-tooltip="true" align="center" v-if="activeName=='待申报'">
              <template slot-scope={row}>{{row.applyTime!=undefined && row.applyTime ? row.applyTime.replace('T',' ') : ''}}</template>
            </el-table-column>
          </div>
          <div v-if="activeName2=='1'">
            <el-table-column prop="projectName" label="项目" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="batchCount" label="当月报税人数合计" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <span class="greenName cp" v-if="activeName=='待确认'" @click="toPerson2('2',row)">{{row.batchCount}}</span>
                <span v-else>{{row.batchCount}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="payrollPaymentCount" label="当月发薪人数" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <span class="greenName cp" v-if="activeName=='待确认'" @click="toPerson2('5',row)">{{row.payrollPaymentCount}}</span>
                <span v-else>{{row.payrollPaymentCount}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="beOnTheJobCount" label="所属期在职人数" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="untreatedJobCount" label="所属期离职人数" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="zeroDeclartionCount" label="当月零申报人数" min-width="130" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <span class="greenName cp" v-if="activeName=='待确认'" @click="toPerson2('3',row)">{{row.zeroDeclartionCount}}</span>
                <span v-else>{{row.zeroDeclartionCount}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bonusCount" label="当月奖金人数" min-width="130" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">
                <span class="greenName cp" v-if="activeName=='待确认'" @click="toPerson2('4',row)">{{row.bonusCount}}</span>
                <span v-else>{{row.bonusCount}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="customerServiceName" label="客服" min-width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="departmentName" label="服务部门" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </div>
          <el-table-column prop="name" label="操作" :min-width="activeName2=='0' && activeName=='待申报' ? 320 : 180" :show-overflow-tooltip="true" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn" v-if="activeName=='个税草稿'">
                <el-button type="text" v-if="activeName2=='0' &&( row.batchStatus==1 || row.batchStatus==2 || activeName2=='2')" @click="toProjict(row)">项目</el-button>
                <el-button type="text" v-if="(activeName2=='0' || activeName2=='1' || activeName2=='2') && (row.batchStatus==1 ||row.batchStatus==2)" @click="toPerson(row)">人员</el-button>
                <!-- <el-button type="text" v-if="activeName2=='0' && activeName=='个税草稿' && (row.batchStatus==1 || row.batchStatus==2 || activeName2=='2')" @click="confirmSubmit([row.id])">提交确认</el-button> -->
              </div>
              <div class="injuryTabBtn" v-if="activeName!='个税草稿'">
                <el-button type="text" v-if="activeName2=='0' && activeName=='待申报'" @click="expErrInfo(row,'DownLoadCheckFaildMessage','校验错误信息')">导出校验错误信息</el-button>
                <el-button type="text" v-if="activeName2=='0' && activeName=='待申报'" @click="expErrInfo(row,'DownLoadTaxFaildMessage','算税错误信息')">导出算税错误信息</el-button>
                <el-button type="text" v-if="activeName2=='0'" @click="toProjict(row)">项目</el-button>
                <!-- <el-button type="text" v-if="activeName2=='0' || activeName2=='1'" @click="toPerson(row)">人员</el-button> -->
                <!-- <el-button type="text" v-if="activeName2=='0' && activeName=='个税草稿' && checkPermission(['incomeDtl_taxSubmit'], permissionLists)" @click="confirmSubmit([row.id])">提交确认</el-button> -->


                <el-popconfirm title="请确定是否确认？" style="margin-left: 10px;" @confirm="confirmCompany(row.id)" v-if="activeName=='待确认' && checkPermission(['incomeDtl_TBCConfirm'], permissionLists) && activeName2=='1'">
                  <el-button type="text" slot="reference">确认</el-button>
                </el-popconfirm>

                <el-popconfirm title="请确定是否确认？" style="margin-left: 10px;" @confirm="confirmCompany([row.id])" v-if="activeName=='待确认' && checkPermission(['incomeDtl_TBCConfirm'], permissionLists) && activeName2=='0'">
                  <el-button type="text" slot="reference">确认</el-button>
                </el-popconfirm>
                <el-popconfirm title="请确定是否撤销？" v-if="activeName2=='0' && activeName=='待确认' && checkPermission(['incomeDtl_TBCRevoke'], permissionLists)" style="margin-left: 10px;" @confirm="revoke([row.id])">
                  <el-button type="text" slot="reference">撤销</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="activeName=='待申报' && checkPermission(['incomeDtl_declaredSubmit'], permissionLists)" @click="applyRow(row)">申报</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange2" :key="'psn'" v-if="activeName2=='2' || activeName2=='3' || activeName2=='4' || activeName2=='5'">
          <el-table-column type="selection" width="40" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="reportingMonth" key="" label="税款所属期" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.reportingMonth!=undefined && row.reportingMonth ? row.reportingMonth.substring(0,7) : ''}}</template>
          </el-table-column>
          <el-table-column prop="payRollCompany" label="申报公司" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="customerName" label="客户名称" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="employeeName" label="姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="cardType" label="证件类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="cardId" label="证件号码" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="phoneNum" label="手机号码" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="nationality" label="国籍" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="typeOfEmployment" label="任职受雇从业类型" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IsConfirmed" label="状态" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='待确认'">
            <template slot-scope="{row}">{{row.IsConfirmed ? '已确认' : '未确认'}}</template>
          </el-table-column>
          <el-table-column prop="dateOfEmployment" label="任职受雇从业日期" width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              {{row.typeOfEmployment ? row.typeOfEmployment.split('T')[0] : ''}}
            </template>
          </el-table-column>
          <div v-if="activeName2=='2'">
            <el-table-column prop="incomeType" label="所得类型" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="currentIncome" label="本期收入" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="currentExemptIncome" label="本期免税收入" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="personalSupport" label="基本养老保险费" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="personalCare" label="基本医疗保险费" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="personalUnemployment" label="失业保险费" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="providentFundCosts" label="住房公积金" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cumulativeChildEducation" label="累计子女教育" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cumulativeContinuingEducation" label="累计继续教育" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accumulatedHousingLoanInterest" label="累计住房贷款利息" width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accumulatedHousingRent" label="累计住房租金" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="supportTheElderlyCumulatively" label="累计赡养老人" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="cumulativeInfantCareCosts" label="累计3岁以下婴幼儿照护" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="accumulatedPersonalPension" label="累计个人养老金" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="enterpriseOccupationalAnnuity" label="企业(职业)年金" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="commercialHealthInsurance" label="商业健康保险" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="taxDeferredPensionInsurance" label="税延养老保险" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="other" label="其他" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="theAmountOfDonationsAllowedForDeduction" label="准予扣除的捐赠额" width="150" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="taxRelief" label="减免税额" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="submissionConfirmationTime" label="提交确认时间" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="taxReturnAttachment" label="报税附件" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </div>
          <div v-if="activeName2=='3'">
            <el-table-column prop="name" label="上月是否申报" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="上月是否发薪" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="在职情况" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="离职日期" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="source" label="来源" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="zeroDeclarationReason" label="零申报原因" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </div>
          <el-table-column label="操作" min-width="100" :show-overflow-tooltip="true" align="center" fixed="right">
            <template slot-scope={row} v-if="activeName2=='3'">
              <div class="injuryTabBtn">
                <el-popconfirm title="请确定是否确认？" @confirm="confirmCompany(row.ids)" v-if="activeName=='待确认'">
                  <el-button type="text" slot="reference">确认</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="Number(listQuery.PageModel.Rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="生成个税草稿" :visible.sync="showGenerate" :show-close="false" width="550px">
      <div v-if="showGenerate">
        <el-form label-width="110px">
          <div class="scItem flex">
            <div class="sc scTitle">申报公司</div>
            <div class="sh scTitle">税号</div>
          </div>
          <div class="scItem flex" v-for="(item,index) in generateData" :key="index">
            <div class="sc">{{item.payRollCompany}}</div>
            <div class="sh">{{item.taxId}}</div>
          </div>
          <!-- <el-form-item label="税款所属期">
            2024/3
          </el-form-item> -->
          <div class="taxBelong flex">
            <div class="scTitle">
              税款所属期
            </div>
            <div class="taxDate">{{generateData[0].reportingMonth.substring(0,7)}}</div>
          </div>
          <el-checkbox v-model="isBuildZeroDeclaration">自动生成零申报人员</el-checkbox>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showGenerate = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="initiateTax" :loading="btnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="applyType == '0' ? '申报报送' : '零申报算税'" :visible.sync="showApply" :show-close="false" width="500px">
      <div v-if="showApply">
        <el-form label-width="110px">
          <div class="scItem flex">
            <div class="sc scTitle">公司名称</div>
            <div class="sh scTitle">税号</div>
          </div>
          <div class="scItem flex" v-for="(item,index) in applyData" :key="index">
            <div class="sc">{{item.payRollCompany}}</div>
            <div class="sh">{{item.taxId}}</div>
          </div>
          <!-- <el-form-item label="税款所属期">
            2024/3
          </el-form-item> -->
          <div class="taxBelong flex">
            <div class="scTitle">
              税款所属期
            </div>
            <div class="taxDate">{{applyData[0].reportingMonth.substring(0,7)}}</div>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showApply = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmApply" v-if="applyType=='0'">确 认</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmApplyTax" v-if="applyType=='1'">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="生成全部公司批次" :visible.sync="showAllGenerate" :show-close="false" width="400px">
      <div>
        <el-form label-width="110px">
          <div class="taxBelong flex">
            <div class="scTitle">
              申报公司
            </div>
            <div class="taxDate">合计XXX家公司</div>
          </div>
          <div class="taxBelong flex">
            <div class="scTitle">
              税款所属期
            </div>
            <div class="taxDate">2024/3</div>
          </div>
          <el-checkbox v-model="isBuildZeroDeclaration">自动生成零申报人员</el-checkbox>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick style="margin-left:10px;" size="small" @click="showAllGenerate = false">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="showAllGenerate = false">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showAllSign" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="!checkOver">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">
          人员校验进行中，预计耗时1~3分钟，请耐心等待......
        </div>
        <!-- <div class="footer">
          <el-button type="danger" size="small" @click="StopCheck" :loading="isloading">终止校验</el-button>
        </div> -->
      </div>
      <div v-if="checkOver">
        人员校验结束，其中
        <span class="num1 success"> {{checkSuccess}} </span>
        人校验成功，<span class="num1 red"> {{checkFailed}} </span>人校验失败
      </div>
      <span slot="footer" class="dialog-footer" v-if="checkOver">
        <el-button size="small" @click="showAllSign = false">关 闭</el-button>
        <el-button size="small" type="primary" @click="continueGetTax">继续算税</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showAllTax" width="500px" :close-on-press-escape="false" :show-close="false">
      <div v-if="!taxOver">
        <div class="Checking">
          <video loading="lazy" muted="muted" src="../../assets/images/loadingCoffe.mp4" type="video/mp4" autoplay="autoplay" loop="loop" style="width:100px;height:auto;object-fit:fill;mix-blend-mode: darken;"></video>
        </div>
        <div class="CheckingTips">算税进行中，预计耗时1~5分钟，请耐心等待.....</div>
        <!-- <div class="footer">
          <el-button type="danger" size="small" @click="StopTax" :loading="isloading">终止算税</el-button>
        </div> -->
      </div>
      <div v-if="taxOver">
        算税结束，其中
        <span class="num1 success"> {{taxSuccess}} </span>
        人算税成功，<span class="num1 red"> {{taxFailed}} </span>
        人失败
        <span v-if="checkFail>0">
          ，可在 算薪结果明细 表格“错误信息”列查看错误信息。请修改人员信息后重新校验，或确认继续对校验成功人员算税。
        </span>
      </div>
      <span slot="footer" class="dialog-footer" v-if="taxOver">
        <el-button size="small" @click="showAllTax = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    number
  } from 'mathjs';
  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "batchStatus",
              order: 1
            }]
          },
          reportingMonth: moment().subtract(1, 'months').format('YYYY-MM'), //税款所属期
          payRollCompany: '', //公司
          taxId: '',
          batchStatus: '', //状态 0未生成 1已生成 2确认退回 3提交确认 4已确认
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        },
        showDropScreen: -1,
        tableData: [{
          name: '666'
        }],
        roleName: localStorage.roleName,
        roletype: localStorage.loginRoletype,
        multipleSelection: [],
        permissionLists: [],
        totalCount: 0,
        activeName: '待确认',
        activeName2: '1',
        loading: false,
        btnLoading: false,
        legList: [],
        multipleSelection2: [],
        showGenerate: false,
        isBuildZeroDeclaration: false, //是否自动生成零申报人员
        showAllGenerate: false, //生成全部公司批次
        generateData: [],
        showApply: false,
        applyData: [],
        exportZeroDeclarationName: '',
        batchForm: { //生成批次参数
          reportingMonth: '',
          payRollCompanyId: [],
          isBuildZeroDeclaration: false
        },
        proNameList: [],
        interval: null,
        showAllSign: false, //校验弹窗
        listid: [], //要查询的listid
        checkSuccess: 0, //校验成功人数
        checkOver: false, //校验是否完成
        checkFailed: 0, //校验失败人数
        checkTotal: 0, //校验全部人数
        taxSuccess: 0, //算税成功人数
        taxOver: 0, //算税是否完成
        taxFailed: 0, //算税失败人数
        taxTotal: 0, //算税成功人数
        showAllTax: false,
        applyType: '',
        rules: {
          ProjectId: {
            required: true,
            message: '请选择发薪项目',
            trigger: 'change'
          },
          IncomeTaxMonth: {
            required: true,
            message: '请选择税款所属期',
            trigger: 'change'
          },
          IncomeTaxType: {
            required: true,
            message: '请选择个税申报类型',
            trigger: 'change'
          },
          AttrMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          Url: {
            required: true,
            message: '请上传薪资表',
            trigger: 'change'
          },
        },
      }
    },
    created() {
      if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
        this.activeName = this.$route.query.activeName;
      }
      this.getButtonPower();
      this.getlegalsubjectlist();
      this.getProList();
      this.changeTab2();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/incomeDtl',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        if (this.activeName == '个税草稿') {
          if (this.activeName2 == '0') {
            //获取个税草稿列表 公司
            this.getDataList('GetIncomeBatchPageList')
          } else if (this.activeName2 == '1') {
            //获取个税草稿列表  项目
            this.getDataList('GetBatchProjectPageList')
          } else {
            //获取个税草稿列表  全部人员/零申报人员
            this.getDataList('GetBatchPersonPageList')
          }
        } else if (this.activeName == '待确认') {
          if (this.activeName2 == '0') {
            //获取待确认列表 公司
            this.getDataList('GetBatchCompanyPageList')
          } else if (this.activeName2 == '1') {
            //获取待确认列表  项目
            this.getDataList('GetWaitingBatchProjectPageList')
          } else {
            //获取待确认列表  全部人员/零申报人员
            this.getDataList('GetBatchDetailPersonPageList')
          }
        } else {
          if (this.activeName2 == '0') {
            this.listQuery.declarationStatus = this.activeName == '待申报' ? 0 : this.activeName == '申报中' ? 1 : this.activeName == '申报成功' ? 2 : 3;
            //获取列表 公司
            this.getDataList('GetInComeDeclarationPageList')
          } else if (this.activeName2 == '1') {
            //获取列表  项目
            this.getDataList('GetDeclarationProjectPageList')
          } else {
            //获取列表  全部人员/零申报人员
            this.getDataList('GetDeclarationPersonPageList')
          }
        }
      },
      getDataList(pagename) {
        this.loading = true;
        xz.getDataList(this.listQuery, pagename).then(res => {
          try {
            this.tableData = res.data.data;
            this.totalCount = Number(res.data.pageModel.totalCount);
            this.loading = false;
          } catch (e) {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
            this.$message.error('获取列表失败')
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab(tab, event) {
        if (tab.index == '1') {
          this.$router.push({
            path: '/incomeDtl'
          })
        } else if (tab.index == '7' || tab.index == '8') {
          this.$router.push({
            path: '/deductionInfo'
          })
        } else if (tab.index == '9') {
          this.$router.push({
            path: '/taxApplySet'
          })
        } else {
          if (this.activeName == '待确认') {
            this.activeName2 = '1';
          } else {
            this.activeName2 = '0';
          }
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: this.activeName == '个税草稿' ? [{
                property: "batchStatus",
                order: 1
              }] : []
            },
            reportingMonth: '', //税款所属期
            payRollCompany: '', //公司
            taxId: '',
            batchStatus: '', //状态 0未生成 1已生成 2确认退回 3提交确认 4已确认
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          this.getList();
        }
      },
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: "batchStatus",
                order: 1
              }]
            },
            reportingMonth: this.listQuery.reportingMonth, //税款所属期
            payRollCompany: this.listQuery.payRollCompany, //公司
            taxId: this.listQuery.taxId,
            batchStatus: '', //状态 0未生成 1已生成 2确认退回 3提交确认 4已确认
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          this.getList();
        } else if (this.activeName2 == '1') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            reportingMonth: this.listQuery.reportingMonth, //税款所属期
            projectId: this.listQuery.projectId, //项目
            departmentId: '',
            customerServiceId: '',
            payRollCompanyId: this.listQuery.payRollCompanyId,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          if (this.activeName == '待申报') {
            this.listQuery.declarationStatus = 0
          } else if (this.activeName == '申报中') {
            this.listQuery.declarationStatus = 1
          } else if (this.activeName == '申报成功') {
            this.listQuery.declarationStatus = 2
          }
          this.getList();
        } else {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            reportingMonth: this.listQuery.reportingMonth, //税款所属期
            taxId: this.listQuery.taxId,
            payRollCompanyId: this.listQuery.payRollCompanyId,
            employeeName: '',
            cardId: '',
            phoneNum: '',
            customerServiceId: '',
            departmentId: '',
            projectId: this.listQuery.projectId,
            incomeType: '',
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }
          if (this.activeName2 == '2') {
            this.listQuery['detailType'] = 1;
          } else if (this.activeName2 == '3') {
            this.listQuery['isZeroDeclaration'] = true
            this.listQuery['detailType'] = 3;
          } else if (this.activeName2 == '4') {
            this.listQuery['detailType'] = 4;
          } else if (this.activeName2 == '5') {
            this.listQuery['detailType'] = 2;
          }
          if (this.activeName == '待申报') {
            this.listQuery.declarationStatus = 0
          } else if (this.activeName == '申报中') {
            this.listQuery.declarationStatus = 1
          } else if (this.activeName == '申报成功') {
            this.listQuery.declarationStatus = 2
          }
          this.getList();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleSelectionChange2(val) {
        this.multipleSelection2 = val;
      },
      //生成个税草稿
      generateBatch() {
        if (this.multipleSelection.length > 0) {
          this.generateData = this.multipleSelection;
          this.showGenerate = true;
        } else {
          this.$message.warning('请至少选择一个生成批次')
        }
      },
      //生成个税草稿 前 发起校验、算税
      initiateTax() {
        this.btnLoading = true;
        // this.showAllSign = true;
        // this.checkOver = false;
        let arr = [];
        this.multipleSelection.forEach((element, index) => {
          arr.push(element.id)
          if (index == this.multipleSelection.length - 1) {
            this.batchForm = {
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
              reportingMonth: this.generateData[0].reportingMonth,
              payRollCompanyId: arr,
              isBuildZeroDeclaration: this.isBuildZeroDeclaration
            }
            xz.CheckBuildInComeDetailBatch(this.batchForm).then(res => {
              try {
                if (res.status == 'ok') {
                  if (res.data.length > 0) {
                    // this.listid = res.data;
                    // clearInterval(this.interval);
                    // setTimeout(() => {
                    //   this.getCheckStatus();
                    // }, 3000);
                    // this.intervalNum = 0;
                    // this.interval = setInterval(this.Refresh, 10000)+
                    this.confirmGenerate()
                  } else { //返回长度为0直接生成个税草稿
                    this.confirmGenerate()
                  }
                } else {
                  this.$message.error(res.msg);
                  this.btnLoading = false;
                }
              } catch {
                this.$message.error('系统出错');
                this.btnLoading = false;
              }
            })
          }
        });
        // this.listid = ['50398aac-61b8-4590-959d-06dc6d36017f'];
        // this.showAllSign = true;
        // this.checkOver = false;
        // clearInterval(this.interval);
        // setTimeout(() => {
        //   this.getCheckStatus();
        // }, 3000);
        // this.intervalNum = 0;
        // this.interval = setInterval(this.Refresh, 10000)
      },
      //申报算薪
      confirmApplyTax() {
        this.btnLoading = true;
        this.showAllSign = true;
        this.checkOver = false;
        let arr = [];
        let entlist = [];
        this.applyData.forEach((element, index) => {
          arr.push(element.id)
          entlist.push(element.payRollCompany)
          if (index == this.applyData.length - 1) {
            this.batchForm = {
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
              reportingMonth: this.applyData[0].reportingMonth,
              payRollCompanyId: arr
            }
            xz.GetApplyInComeCheckList(this.batchForm).then(res => {
              try {
                if (res.status == 'ok') {
                  if (res.data.length > 0) {
                    this.listid = res.data;
                    let dd = {
                      issend: "true",
                      entname: entlist.toString(),
                      datestr: this.applyData[0].reportingMonth,
                      userid: Cookies.get("userid-b"),
                      ids: this.listid
                    }
                    xz.sendUserALLToXFTDeclartion(dd).then(res => {
                      if (res.status == 'ok') {
                        clearInterval(this.interval);
                        setTimeout(() => {
                          this.getCheckStatus();
                        }, 3000);
                        this.intervalNum = 0;
                        this.interval = setInterval(this.Refresh, 10000)
                        // this.showApply = false;
                        // this.$message.success('发起算税成功！');
                        // this.btnLoading = false;
                      } else {
                        this.showAllSign = false;
                        this.checkOver = true;
                        // this.showApply = false;
                        // this.$message.error(res.msg)
                      }
                    })
                  } else {
                    this.$message.success('无需算税');
                    this.showApply = false;
                    this.showAllSign = false;
                    this.checkOver = true;
                  }
                } else {
                  this.showApply = false;
                  this.$message.error(res.msg);
                  this.btnLoading = false;
                  this.showAllSign = false;
                }
              } catch (e) {
                this.showApply = false;
                this.$message.error('系统出错');
                console.log(e)
                this.showAllSign = false;
                this.btnLoading = false;
              }
            })
          }
        });
      },
      getCheckStatus() {
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.PullInComeStatus(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.checkSuccess = res.data.success;
              this.checkOver = res.data.over;
              this.checkFailed = res.data.failed;
              this.checkTotal = res.data.total;
              if (res.data.over) {
                clearInterval(this.interval);
              }
            } else {
              this.$message.error(res.msg);
              clearInterval(this.interval);
              this.showAllSign = false;
              this.showGenerate = false;
            }
          } catch (e) {}
        })
      },
      Refresh() {
        this.intervalNum++;
        this.getCheckStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 360) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllSign = false;
          this.$message.warning('查询超时！')
        }
      },
      //继续算税
      continueGetTax() {
        this.showAllSign = false;
        this.showAllTax = true;
        this.taxOver = false;
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.CheckCacuTaxInComeDetailBatch(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.showAllSign = true;
              this.checkOver = false;
              clearInterval(this.interval);
              setTimeout(() => {
                this.getTaxStatus();
              }, 3000);
              this.intervalNum = 0;
              this.interval = setInterval(this.Refresh2, 10000)
            } else {
              this.$message.error(res.msg);
              this.btnLoading = false;
            }
          } catch {
            this.$message.error('系统出错');
            this.btnLoading = false;
          }
        })
      },
      //查询算税状态
      getTaxStatus() {
        let data = {
          applySalaryId: this.listid,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.PullInComeTaxCacuStatus(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.taxSuccess = res.data.success;
              this.taxOver = res.data.over;
              this.taxFailed = res.data.failed;
              this.taxTotal = res.data.total;
              if (res.data.over) {
                clearInterval(this.interval);
                this.showAllSign = false;
                this.showAllTax = false;
                this.$message.success('算税完成')
              }
            } else {
              this.$message.error(res.msg);
              clearInterval(this.interval);
              this.showAllSign = false;
              this.showGenerate = false;
            }
          } catch (e) {}
        })
      },
      Refresh2() {
        this.intervalNum++;
        this.getTaxStatus();
        console.log('intervalNum', this.intervalNum)
        if (this.intervalNum == 360) {
          this.intervalNum = 0;
          clearInterval(this.interval);
          this.showAllTax = false;
          this.$message.warning('查询超时！')
        }
      },
      //确认生成个税草稿
      confirmGenerate() {
        // let arr = [];
        // this.multipleSelection.forEach((element, index) => {
        //   arr.push(element.id)
        //   if (index == this.multipleSelection.length - 1) {
        //     let data = {
        //       reportingMonth: this.generateData[0].reportingMonth,
        //       payRollCompanyId: arr,
        //       isBuildZeroDeclaration: this.isBuildZeroDeclaration
        //     }

        //   }
        // });
        xz.BuildInComeDetailBatch(this.batchForm).then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('生成批次成功！');
              this.showGenerate = false;
              this.showAllSign = false;
              this.showAllTax = false;
              this.btnLoading = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.showGenerate = false;
              this.showAllSign = false;
              this.showAllTax = false;
              this.btnLoading = false;
              this.getList();
            }
          } catch {
            this.$message.error('系统出错');
            this.showGenerate = false;
          }
        })
      },
      //查看项目数据
      toProjict(row) {
        this.activeName2 = '1';
        this.listQuery.payRollCompanyId = row.payRollCompanyId
        this.changeTab2();
        // this.listQuery = {
        //   PageModel: {
        //     Rows: 10,
        //     Page: 1,
        //     OrderInput: []
        //   },
        //   reportingMonth: '', //税款所属期
        //   projectId: row.projectId, //项目
        //   departmentId: '',
        //   customerServiceId: '',
        //   payRollCompanyId: row.payRollCompanyId
        // }
        // this.getList();
      },
      //查看人员信息
      toPerson(row) {
        this.activeName2 = '2';
        this.listQuery.projectId = number(row.projectId)
        this.changeTab2();
        // this.listQuery = {
        //   PageModel: {
        //     Rows: 10,
        //     Page: 1,
        //     OrderInput: []
        //   },
        //   reportingMonth: '', //税款所属期
        //   taxId: '',
        //   payRollCompanyId: '',
        //   employeeName: '',
        //   cardId: '',
        //   phoneNum: '',
        //   customerServiceId: '',
        //   departmentId: '',
        //   projectId: '',
        //   incomeType: '',
        //   batchStatus: ''
        // }
        // this.getList();
      },
      toPerson2(type, row) {
        this.activeName2 = type;
        this.listQuery.projectId = number(row.projectId)
        this.changeTab2();
      },
      //批量提交
      batchSubmit() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          let canPay = true;
          this.multipleSelection.forEach((element, index) => {
            arr.push(element.id)
            // if (element.batchStatus != 1) {
            //   canPay = false;
            // }
            if (index == this.multipleSelection.length - 1) {
              this.confirmSubmit(arr)
              // if (canPay) {
              //   this.confirmSubmit(arr)
              // } else {
              //   this.$message.warning('只有已生成的才可以提交确认')
              // }
            }
          });
        } else {
          this.$message.warning('请至少选择一个')
        }
      },
      //确认提交
      confirmSubmit(ids) {
        this.loading = true;
        let data = {
          id: ids,
          batchStatus: 3,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.SetInComeDetailBatchStatus(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('确认提交成功！');
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.getList();
            }
          } catch {
            this.$message.error('系统出错');
          }
        })
      },
      //导出列表
      exportList() {
        if (this.activeName == "个税草稿") {
          if (this.activeName2 == '0') {
            this.loading = true;
            let data = {
              reportingMonth: this.listQuery.reportingMonth,
              payRollCompany: this.listQuery.payRollCompany,
              taxId: this.listQuery.taxId,
              batchStatus: this.listQuery.batchStatus,
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
            }
            xz.ExportIncomeBatchPageList(data).then(res => {
              try {
                var data = new Blob([res], {
                  type: "application/vnd.ms-excel;charset=utf-8"
                });
                var downloadUrl = window.URL.createObjectURL(data);
                var anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = this.activeName + '列表（公司）' + ".xlsx";
                anchor.click();
                window.URL.revokeObjectURL(data);
                this.loading = false;
              } catch (e) {
                this.loading = false;
                this.$message.error('导出异常')
              }
            })
          } else if (this.activeName2 == '1') {
            this.loading = true;
            let data = {
              reportingMonth: this.listQuery.reportingMonth,
              projectId: this.listQuery.projectId,
              departmentId: this.listQuery.departmentId,
              customerServiceId: this.listQuery.customerServiceId,
              payRollCompanyId: this.listQuery.payRollCompanyId
            }
            xz.ExportBatchProjectList(data).then(res => {
              try {
                var data = new Blob([res], {
                  type: "application/vnd.ms-excel;charset=utf-8"
                });
                var downloadUrl = window.URL.createObjectURL(data);
                var anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = this.activeName + '列表（项目）' + ".xlsx";
                anchor.click();
                window.URL.revokeObjectURL(data);
                this.loading = false;
              } catch (e) {
                this.loading = false;
                this.$message.error('导出异常')
              }
            })
          } else if (this.activeName2 == "2" || this.activeName2 == "3") {
            if (this.activeName2 === "2") {
              this.exportZeroDeclarationName = "全部人员";
            } else {
              this.exportZeroDeclarationName = "零申报人员";
            }
            this.loading = true;
            let data = {
              reportingMonth: this.listQuery.reportingMonth,
              projectId: this.listQuery.projectId,
              departmentId: this.listQuery.departmentId,
              customerServiceId: this.listQuery.customerServiceId,
              payRollCompanyId: this.listQuery.payRollCompanyId,
              taxId: this.listQuery.taxId,
              isZeroDeclaration: this.activeName2 === "2" ? null : true
            }
            xz.ExportBatchPersonList(data).then(res => {
              try {
                var data = new Blob([res], {
                  type: "application/vnd.ms-excel;charset=utf-8"
                });
                var downloadUrl = window.URL.createObjectURL(data);
                var anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = this.activeName + this.exportZeroDeclarationName + ".xlsx";
                anchor.click();
                window.URL.revokeObjectURL(data);
                this.loading = false;
              } catch (e) {
                this.loading = false;
                this.$message.error('导出异常')
              }
            })
          }
        } else if (this.activeName == "待确认") {
          //这里我把上面的个税草稿全部拷贝了一遍，有没有办法复用？
          if (this.activeName2 == '0') {
            this.loading = true;
            let data = {
              reportingMonth: this.listQuery.reportingMonth,
              payRollCompany: this.listQuery.payRollCompany,
              taxId: this.listQuery.taxId,
              batchStatus: this.listQuery.batchStatus,
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
            }
            xz.ExportBatchCompanyList(data).then(res => {
              try {
                var data = new Blob([res], {
                  type: "application/vnd.ms-excel;charset=utf-8"
                });
                var downloadUrl = window.URL.createObjectURL(data);
                var anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = this.activeName + '列表（公司）' + ".xlsx";
                anchor.click();
                window.URL.revokeObjectURL(data);
                this.loading = false;
              } catch (e) {
                this.loading = false;
                this.$message.error('导出异常')
              }
            })
          } else if (this.activeName2 == '1') {
            this.loading = true;
            let data = {
              reportingMonth: this.listQuery.reportingMonth,
              projectId: this.listQuery.projectId,
              departmentId: this.listQuery.departmentId,
              customerServiceId: this.listQuery.customerServiceId,
              payRollCompanyId: this.listQuery.payRollCompanyId,
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
            }
            xz.ExportWaitingBatchProjectPageList(data).then(res => {
              try {
                var data = new Blob([res], {
                  type: "application/vnd.ms-excel;charset=utf-8"
                });
                var downloadUrl = window.URL.createObjectURL(data);
                var anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = this.activeName + '列表（项目）' + ".xlsx";
                anchor.click();
                window.URL.revokeObjectURL(data);
                this.loading = false;
              } catch (e) {
                this.loading = false;
                this.$message.error('导出异常')
              }
            })
          } else {
            this.loading = true;
            let data = {
              reportingMonth: this.listQuery.reportingMonth,
              projectId: this.listQuery.projectId,
              departmentId: this.listQuery.departmentId,
              customerServiceId: this.listQuery.customerServiceId,
              payRollCompanyId: this.listQuery.payRollCompanyId,
              taxId: this.listQuery.taxId,
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
            }
            if (this.activeName2 == '2') {
              this.exportZeroDeclarationName = "当月报税人员";
              data['detailType'] = 1;
            } else if (this.activeName2 == '3') {
              this.exportZeroDeclarationName = "零申报人员";
              data['detailType'] = 3;
              data['isZeroDeclaration'] = true;
            } else if (this.activeName2 == '4') {
              this.exportZeroDeclarationName = "奖金人员";
              data['detailType'] = 4;
            } else if (this.activeName2 == '5') {
              this.exportZeroDeclarationName = "当月发薪人员";
              data['detailType'] = 2;
            }
            xz.ExportBatchDetailPersonPageList(data).then(res => {
              try {
                var data = new Blob([res], {
                  type: "application/vnd.ms-excel;charset=utf-8"
                });
                var downloadUrl = window.URL.createObjectURL(data);
                var anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = this.activeName + this.exportZeroDeclarationName + ".xlsx";
                anchor.click();
                window.URL.revokeObjectURL(data);
                this.loading = false;
              } catch (e) {
                this.loading = false;
                this.$message.error('导出异常')
              }
            })
          }
        } else {
          if (this.activeName2 == '0') {
            this.loading = true;
            this.exportf('ExportInComeDeclarationPageList', this.activeName + '公司列表')
          } else if (this.activeName2 == '1') {
            this.loading = true;
            this.exportf('ExportDeclarationProjectPageList', this.activeName + '项目列表')
          } else {
            this.loading = true;
            this.exportf('ExportDeclarationPersonPageList', this.activeName + '人员列表')
          }
        }
      },
      //导出校验/ 算税 信息
      expErrInfo(row, pagename, name) {
        let data = {
          id: row.id
        }
        xz.expErrInfo(data, pagename).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = name + ".xlsx";
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('导出异常')
          }
        })
      },
      exportf(pagename, name) {
        xz.exportTaxList(pagename, this.listQuery).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = name + ".xlsx";
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.loading = false;
          } catch (e) {
            this.loading = false;
            this.$message.error('导出异常')
          }
        })
      },
      //批量确认
      batchConfirmCompany() {
        if (this.activeName2 == 0) {
          if (this.multipleSelection.length > 0) {
            let arr = [];
            this.multipleSelection.forEach((element, index) => {
              arr.push(element.id)
              if (index == this.multipleSelection.length - 1) {
                this.confirmCompany(arr)
              }
            });
          } else {
            this.$message.warning('请至少选择一个')
          }
        } else if (this.activeName2 == 1) {
          if (this.multipleSelection.length > 0) {
            let arr = [];
            this.multipleSelection.forEach((element, index) => {
              arr = arr.concat(element.id)
              if (index == this.multipleSelection.length - 1) {
                this.confirmCompany(arr)
              }
            });
          } else {
            this.$message.warning('请至少选择一个')
          }
        } else {
          if (this.multipleSelection2.length > 0) {
            let arr = [];
            this.multipleSelection2.forEach((element, index) => {
              // arr.push(element.ids)
              arr = arr.concat(element.ids)
              if (index == this.multipleSelection2.length - 1) {
                this.confirmCompany(arr)
              }
            });
          } else {
            this.$message.warning('请至少选择一个')
          }
        }

      },
      confirmCompany(arr) {
        let data = {
          id: arr,
          batchStatus: 4,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        this.loading = true;
        let pagename = this.activeName2 == '0' ? 'SetInComeBatchStatus' : this.activeName2 == '1' ? 'SetBatchProjectStatus' : 'SetBatchPersonStatus';
        xz.SetInComeBatchStatus(data, pagename).then(res => {
          try {
            if (res.status == 'ok') {
              this.getList();
              this.$message.success('确认成功');
              this.loading = false;
            } else {
              this.getList();
              this.$message.error(res.msg);
              this.loading = false;
            }
          } catch (e) {
            this.loading = false;
            this.$message.error('系统出错')
          }
        })
      },
      //批量撤销
      batchRevoke() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach((element, index) => {
            arr.push(element.id)
            if (index == this.multipleSelection.length - 1) {
              this.revoke(arr)
            }
          });
        } else {
          this.$message.warning('请至少选择一个')
        }
      },
      //撤销
      revoke(ids) {
        if (!this.loading) {
          let data = {
            id: ids,
            batchStatus: 2,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          this.loading = true;
          xz.DismissInComeBatchStatus(data).then(res => {
            try {
              if (res.status == 'ok') {
                this.getList();
                this.$message.success('撤销成功');
                this.loading = false;
              } else {
                this.getList();
                this.$message.error(res.msg);
                this.loading = false;
              }
            } catch (e) {
              this.loading = false;
              this.$message.error('系统出错')
            }
          })
        }
      },
      //选中申报
      batchApply(type) {
        if (this.multipleSelection.length > 0) {
          this.applyData = this.multipleSelection;
          console.log(this.applyData)
          this.applyType = type;
          this.showApply = true;
        } else {
          this.$message.warning('请至少选择一个')
        }
      },
      applyRow(row) {
        this.applyData = this.multipleSelection = [row];
        this.showApply = true;
      },
      confirmApply() {
        let arr = [];
        this.multipleSelection.forEach((element, index) => {
          arr.push(element.id)
          if (index == this.multipleSelection.length - 1) {
            let data = {
              id: arr,
              reportingMonth: this.multipleSelection[0].reportingMonth,
              isFirstDeclaration: true, // 申报 true / 重报 false
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype,
            }
            xz.ApplyIncomeDeclaration(data).then(res => {
              try {
                if (res.status == 'ok') {
                  this.getList();
                  this.$message.success('申报成功');
                  this.showApply = false;
                  this.loading = false;
                } else {
                  this.getList();
                  this.$message.error(res.msg);
                  this.loading = false;
                  this.showApply = false;
                }
              } catch (e) {
                this.loading = false;
                this.showApply = false;
                this.$message.error('系统出错')
              }
            })
          }
        });
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.batchStatus == 0) {
          return 'warning-row';
        } else {
          return '';
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .sc {
    width: 280px;
    text-align: center;
    font-size: 14px;
  }

  .sh {
    margin-left: 20px;
    width: 200px;
    text-align: center;
    font-size: 14px;
  }

  .scTitle {
    font-weight: 600;
  }

  .scItem {
    margin-bottom: 10px;
  }

  .taxBelong {
    margin: 15px 0;
    line-height: 24px;
  }

  .taxDate {
    margin-left: 15px;
    font-size: 14px;
  }

  .red {
    color: red;
  }

  .success {
    color: #19BD92;
  }

  .Checking {
    display: flex;
    justify-content: center;
  }

  .CheckingTips {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }

  .greenName {
    text-decoration: underline;
  }
</style>
<style>
  .page_tax .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tax .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tax .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tax .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tax .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tax .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tax .el-table .warning-row {
    background: #E6FCC5;
  }

  .page_tax #tab-所得明细 {
    background: #FFFF00;
  }

  .page_tax #tab-待确认 {
    background: #FFFF00;
  }
</style>